export default __webpack_public_path__ + "static/media/default-image.ea33721f.jpg";